import FontFaceObserver from 'fontfaceobserver';

export default () => {
	const $html = document.getElementsByTagName('html')[0];
	const heading = new FontFaceObserver('ABCDiatypeExpanded-Bold');
	const headingAlt = new FontFaceObserver('ABCDiatype-Regular');
	const body = new FontFaceObserver('Grit-Regular');

	Promise.all([heading.load(), headingAlt.load(), body.load()])
		.then(() => $html.classList.add('fonts-loaded'))
		.catch(() => $html.classList.add('fonts-failed'));
};
